// extracted by mini-css-extract-plugin
module.exports = {"main":"TransationsSuccessMain_main__2_ssH","head":"TransationsSuccessMain_head__DxKbl","btn":"TransationsSuccessMain_btn__29Ogq","image":"TransationsSuccessMain_image__x0bR1"};